import React from 'react';
import {Typography} from 'lark';
import './index.less';

const {Paragraph} = Typography;

interface Props {
    isScaned: boolean;
}

const QRCodeExplain = (props: Props) => {
    const {isScaned} = props;
    return (
        <div className="qr-code-explain-wrapper">
            {isScaned && <Paragraph className="scan-success-title">扫码成功</Paragraph>}
            {isScaned
                ? <Paragraph className="scaned-explain">请在灵犀/企业微信确认登录</Paragraph>
                : <Paragraph className="scaning-explain">请通过灵犀/企业微信扫码登录</Paragraph>}
        </div>
    );
};
export default QRCodeExplain;
